var $ = require('jquery');
var page = require('diy/page/page');
var additionalDialog = require('diy/use-case/edit-session/additional-dialog');

/*global document, diy, jimdoData, console*/
(function () {
    "use strict";

    var useCase = this;

    this.getInstance = function() {
        return useCase;
    };

    this.init = function () {
        this.initEditSessionDialog();
    };

    this.initEditSessionDialog = function () {
        var useCaseIdOfPage = useCase.isEditSession();
        if (useCaseIdOfPage) {
            useCase.referenceDialog = additionalDialog.referenceDialog();
            useCase.referenceDialog.init(useCaseIdOfPage);
        }
    };

    this.isEditSession = function () {
        // check if there is a property named useCase
        if (!jimdoData.hasOwnProperty('useCase')) {
            return false;
        }

        // check if use case is enabled
        if (!jimdoData.useCase.enabled) {
            return false;
        }

        // check if project type either edit-session-bc or edit-session-uc
        var projectType = jimdoData.useCase.projectType;
        if ($.inArray(projectType, ['edit-session-bc', 'edit-session-uc']) === -1) {
            return false;
        }

        // check if showReferenceDialogAndBlockPageEditing false
        if (!jimdoData.useCase.showReferenceDialogAndBlockPageEditing) {
            return false;
        }

        //check if the current page is a use cased page
        var currentPageId = page.getCurrentPageId();
        if (typeof(jimdoData.useCase.referenceDialogPages[currentPageId]) != 'undefined') {
            return jimdoData.useCase.referenceDialogPages[currentPageId].use_case_id;
        }

        return false;
    };

}.call(exports));



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/use-case/index.js
 ** module id = 1141
 ** module chunks = 0
 **/